import { toast } from 'react-toastify';
import appApi from '../../../../../../../../api/app-api';

export const addManualWorkingHoursOperation = async (
  userId: number,
  branchId: number | null,
  activityTypeId: number | null,
  rateId: number | null,
  date: Date | null,
  startTime: Date | null,
  endTime: Date | null,
  workingHoursId?: number | null, // Optional ID for edit mode
) => {
  try {
    if (
      !date ||
      !startTime ||
      !endTime ||
      !activityTypeId ||
      !branchId ||
      !rateId
    ) {
      toast.warn('יש למלא את כל השדות');
      return;
    }

    // Combine date's year/month/day with startTime's hours/minutes
    const combinedStartTime = new Date(date);
    combinedStartTime.setHours(
      startTime.getHours(),
      startTime.getMinutes(),
      0,
      0,
    );

    // Combine date's year/month/day with endTime's hours/minutes
    const combinedEndTime = new Date(date);
    combinedEndTime.setHours(endTime.getHours(), endTime.getMinutes(), 0, 0);

    // For now, use the same API call for both add and edit modes
    // The backend can be updated later to handle edit mode with the workingHoursId
    if (workingHoursId) {
      await appApi.updateManualWorkingHours(
        workingHoursId,
        userId,
        branchId,
        activityTypeId,
        rateId,
        combinedStartTime,
        combinedEndTime,
      );
    } else {
      await appApi.addManualWorkingHours(
        userId,
        branchId,
        activityTypeId,
        rateId,
        combinedStartTime,
        combinedEndTime,
      );
    }
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים...');
    console.error(
      `addManualWorkingHoursOperation is failed with the userId: ${userId}, branchId: ${branchId}, activityTypeId: ${activityTypeId}, rateId: ${rateId}, date: ${date}, startTime: ${startTime}, endTime: ${endTime}, workingHoursId: ${workingHoursId} with the error: ${e}`,
    );
  }
};
